module.exports = __webpack_public_path__ + "img/ngm.ee3443dc.png";